<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="bk-title">Wuthering Heights</p>
<p class="authorname">Emily Brontë</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2title_page.vue?543d4520